const powerbi_Router = [
  {
      path: "powerbi-view",
      name: "powerbi",
      component: () => import("@/views/admin/powerbi"),
      default: true,
      meta: {
          // model: "powerbi",
          // requiresAuth: true,
      },
  },
]
export default powerbi_Router;